export const hasExtension = (fileName: string, exts: string[]) => (new RegExp(`(${ exts.join('|').replaceAll(' ', '').replace(/\./g, '\\.') })$`)).test(fileName);
